import { Component, Injectable, OnInit, Input, Compiler } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '../../../../../../app/services/authentication.service';
import { AlertService } from '../../../../../../app/utils/alert.service';
import { DataPackLine } from '../../../../../models/dataPackLine.model';
import { DataPackService } from '../../../../../../app/models/DataPackService.model'
import { BindComponentService } from '../../../../../utils/bind.component.service';
import { BlockGroupService } from '../../../../../services/block.group.service';
import { DataPackSelectItem } from '../../../../../models/DataPackSelectItem.model';

/**
 * this.author Wesley Mascarenhas
 * @version $Id: content.component.ts 62312 2017-09-12 17:39:13Z bernardo.d.siqueira $
 */
@Component({
  selector: 'blockModal',
  templateUrl: './content.modal.template.html'
})

@Injectable()
export class ModalBloqueioVozComponent   implements OnInit {

  @Input() listAcount: any;
  @Input() lineNew: DataPackLine = new DataPackLine();
  private listOpcoesBlockLines: Map<string,DataPackService> = new Map<string,DataPackService>();
  private configMultipleBlockVoice: DataPackLine = new DataPackLine();
  private isContinuar: boolean = true;

  constructor(private activeModal: NgbActiveModal, private authService: AuthenticationService, private alertService: AlertService, private bindComponent : BindComponentService,private blockGroupService : BlockGroupService){
    
  }

  public ngOnInit() {
    
  }

  private loadView(){
    
  }

  private close() {
    this.activeModal.dismiss();
  }

  private clear(){
     this.lineNew = new DataPackLine();
     this.listOpcoesBlockLines = new Map<string,DataPackService>();
     this.configMultipleBlockVoice = new DataPackLine();
     let isConfigsBloqueio: boolean = false;
  }

  private selectLineBlockLines($event, opcao: DataPackService) {
    let check =  $event.srcElement.checked ;
    if (check)  {
      this.listOpcoesBlockLines.set(opcao.serviceCode,opcao);
    } else {
      this.listOpcoesBlockLines.delete(opcao.serviceCode);
    }
  
  }

  private selectAllControlLines($event) {
    let checked = $event.srcElement.checked;
    if (checked) {
      this.lineNew.lineControlDataPackServices.forEach(
      line => {   if ( line.editable ) {
                      this.listOpcoesBlockLines.set(line.serviceCode,line)
                  }
              });   
    } else {
     this.listOpcoesBlockLines = new Map<string,DataPackService>()
    }
  }
 
  public continuar(){
    let isConfigsBloqueio: boolean = true; 
    this.listOpcoesBlockLines.forEach(service=>{
      if (!service.editable) {
        this.listOpcoesBlockLines.delete(service.serviceCode);
      }else{
        service.serviceState = "BLK";
        service.carriersList = new Array<DataPackSelectItem>();
        service.allowedNumber = new Array<DataPackSelectItem>();
        service.blockedNumber = new Array<DataPackSelectItem>();
      }
    });
    this.bindComponent.set(BindComponentService.LIST_CONFIG_BLOC_VOICE,this.listOpcoesBlockLines);
    this.bindComponent.set(BindComponentService.BLOCK_VOICE_DATA_PACK_LINE, this.lineNew );
    this.bindComponent.set(BindComponentService.LIST_ACOUNT_BLOC_VOICE, this.listAcount );
    this.bindComponent.set(BindComponentService.OPEN_SCREEN_BLOC_VOICE, isConfigsBloqueio );
    this.close();
  }

}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/block/voice/blockModal/content.component.ts